import enUS from "antd/locale/en_US";
import trTR from "antd/locale/tr_TR";
import itIT from "antd/locale/it_IT";
import esES from "antd/locale/es_ES";
import deDE from "antd/locale/de_DE";
import arEG from "antd/locale/ar_EG";
import { normalizeAppLanguage } from "util/locale";

const ANTD_LOCALE_MAP = {
  en: enUS,
  tr: trTR,
  it: itIT,
  es: esES,
  de: deDE,
  ar: arEG,
};

export function getAntdLocale(language) {
  const code = normalizeAppLanguage(language);
  return ANTD_LOCALE_MAP[code] || ANTD_LOCALE_MAP.en;
}
